
<vb-ui-form-group>
	<label for="avSelectCamera" #uiLabel>{{ 'Event_Producer_SelectCamera' | translate }}</label>
	<select uiControl class="form-select" #selectElement id="avSelectCamera" name="avSelectCamera" [(ngModel)]="cameraAction" (ngModelChange)="setCamera(cameraAction)">
		<option></option>
		@if (camera && !streams.cameraStream) {
			<option [ngValue]="'start'">
				{{ 'Event_SelfProduced_StartCam' | translate}}
			</option>
		}
		@if (camera && streams.cameraStream) {
			<option [ngValue]="'stop'">
				{{ 'Event_SelfProduced_StopCam' | translate }}
			</option>
		}
		<option [ngValue]="'auto'"> {{'Capture_ChooseCameraAutomatically' | translate}} </option>
		@for (device of streams.cameraDevices; track $index) {
			<option [ngValue]="device">
				{{ device.label }}
			</option>
		}
	</select>
</vb-ui-form-group>
@if (!streams.cameraDevices.length) {
	<span class="warning">{{'Event_Producer_NoCamera' | translate}}</span>
}

<vb-ui-form-group>
	<label for="avSelectMic" #uiLabel>{{ 'Event_Producer_SelectMic' | translate }}</label>

	<select uiControl class="form-select" #selectElement id="avSelectMic" name="avSelectMic" [(ngModel)]="micAction" (ngModelChange)="setMic(micAction)">

		<option></option>
		@if (streams.micStream) {
			<option [ngValue]="'toggleMute'">
				{{(streams.micMuted ? 'Event_SelfProduced_Unmute' : 'Event_SelfProduced_Mute') | translate}}
			</option>
		}
		<option [ngValue]="'auto'"> {{'Capture_ChooseMicAutomatically' | translate}} </option>
		@for (device of streams.micDevices; track $index) {
			<option [ngValue]="device">
				{{ device.label }}
			</option>
		}

	</select>
</vb-ui-form-group>
@if (!streams.micDevices.length) {
	<span class="warning">{{'Event_Producer_NoMic' | translate}}</span>
}
